import * as React from 'react';
import { Component } from 'react';
import { computed } from 'mobx';
import { observer, inject } from 'mobx-react';
import { withTheme } from 'styled-components';
import FundManagers from './FundManagers';
import getQueryResults from '../utils/query/getQueryResults';
import { DataStore } from '../stores';
import { FundManagersOrchestrationConfig } from '../models/configuration/components/FundManagersOrchestration';
import { FundManagers as FundManagersConfig } from '../models/configuration/components/FundManagers';
import { isNullOrEmpty } from '@kurtosys/ksys-app-template/dist/utils/typeChecks';
import { IEntity } from '@kurtosys/ksys-api-client/dist/models/commonTypes';
import { replacePlaceholders } from '../utils/replacePlaceholders';
import { IQueryContext } from '@kurtosys/ksys-app-template/dist/models/query';

interface FundManagersOrchestrationProps {
    dataStore?: DataStore;
    shareClass: IEntity;
    queryContext: IQueryContext;
    fundManagersOrchestrationConfig: FundManagersOrchestrationConfig;
    fundManagersConfig: FundManagersConfig;
    isMobile?: boolean;
}

@inject('dataStore')
@observer
class FundManagersOrchestration extends Component<
    FundManagersOrchestrationProps
> {
    constructor(props) {
        super(props);
    }

    @computed
    get fundManagerQueryData() {
        const {
            shareClass,
            dataStore,
            queryContext,
            fundManagersOrchestrationConfig: config,
        } = this.props;
        if (shareClass && config) {
            const query = config.data;
            const results = getQueryResults(
                queryContext,
                { data: query },
                dataStore.culture
            );
            // Grouping based on the label
            if (results && results.data) {
                const keys = [];
                results.data = results.data.filter(row => {
                    const value = row[config.label];
                    if (keys.indexOf(value) === -1) {
                        keys.push(value);
                        return row;
                    }
                });
            }
            return results.data;
        }
    }

    orchestratedFundManagerProps(data) {
        const {
            fundManagersOrchestrationConfig: config,
            fundManagersConfig,
            isMobile,
        } = this.props;

        if (config && fundManagersConfig) {
            const newFundManagerConfig = { ...fundManagersConfig };
            const label = data[config.label] || '';
            const name = data[config.name] || '';
            let imageSrc = '';

            if (config.imageSrc) {
                const imageSrcKey = data[config.imageSrc.key];
                imageSrc = replacePlaceholders({
                    values: { key: imageSrcKey },
                    text: config.imageSrc.placeholder,
                });
            }
            newFundManagerConfig.label = label;
            const fundManagerProps = {
                fundManagers: [
                    {
                        code: label,
                        name,
                    },
                ],
                fundManagersConfig: newFundManagerConfig,
                imageSrc,
                showHeading: true,
                isMobile,
            };
            return fundManagerProps;
        }
        return {};
    }

    @computed
    get fundManagerComponent() {
        const data = this.fundManagerQueryData;
        if (data) {
            return data.map((elem, idx) => {
                const props = this.orchestratedFundManagerProps(elem);
                return <FundManagers key={`${elem.label}${idx}`} {...props} />;
            });
        }
        return null;
    }

    render() {
        const { fundManagerComponent } = this;
        if (isNullOrEmpty(fundManagerComponent)) {
            return null;
        }
        return fundManagerComponent;
    }
}

export default withTheme(FundManagersOrchestration) as any;



// WEBPACK FOOTER //
// ./src/Components/FundManagersOrchestration.tsx